<template>
  <section ref="raiz" class="lluvia-sobres">
    <!-- 🎥 Background Video vv1.mp4 -->
    <video
      class="video-fondo"
      autoplay
      loop
      muted
      playsinline
      aria-hidden="true"
    >
      <source src="@/assets/vv1.mp4" type="video/mp4" />
    </video>

    <!-- Main Content -->
    <div class="contenido">
      <h2 ref="tituloRef" class="titulo">
        <span class="serif">Card</span><br />
        <span class="script">Box</span>
      </h2>

      <p ref="textoRef" class="texto">
        Your presence is the greatest gift! ✨<br />
        However, if you wish to honor me with a gift,<br />
        a card box will be available.
      </p>

      <img ref="sobreRef" :src="sobrePng" alt="Envelope" class="icono-sobre" />

      <p ref="graciasRef" class="gracias">THANK YOU!</p>
    </div>

    <!-- Containers for GSAP envelope animation -->
    <div ref="lluviaIzq" class="lluvia lluvia-izq" aria-hidden="true"></div>
    <div ref="lluviaDer" class="lluvia lluvia-der" aria-hidden="true"></div>
  </section>
</template>
<script>
import { ref, onMounted, onUnmounted, nextTick } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import sobrePng from '@/assets/ss.png'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'LluviaDeSobres',
  setup() {
    const raiz = ref(null)
    const florRef = ref(null)
    const tituloRef = ref(null)
    const textoRef = ref(null)
    const sobreRef = ref(null)
    const graciasRef = ref(null)
    const lluviaIzq = ref(null)
    const lluviaDer = ref(null)

    let toDer = null
    let toIzq = null
    let stInstance = null

    // Animación de caída de sobres con GSAP
    const crearLluvia = (contenedorEl, lado = 'der', cantidad = 10) => {
      if (!contenedorEl) return
      for (let i = 0; i < cantidad; i++) {
        const el = document.createElement('img')
        el.src = sobrePng
        el.alt = ''
        el.className = 'sobre-lluvia'

        if (!contenedorEl.appendChild) return
        contenedorEl.appendChild(el)

        const rndDelay = gsap.utils.random(0, 0.5)
        const rndDur = gsap.utils.random(1.8, 2.6)
        const rndScale = gsap.utils.random(0.35, 0.7)
        const rndRot = gsap.utils.random(-25, 25)
        const xStart = lado === 'der' ? 110 : -10
        const xEnd = lado === 'der' ? -20 : 120
        const yStart = gsap.utils.random(-20, 20)
        const yEnd = gsap.utils.random(120, 140)

        gsap.fromTo(
          el,
          { xPercent: xStart, yPercent: yStart, rotate: rndRot, scale: rndScale, opacity: 0 },
          {
            xPercent: xEnd,
            yPercent: yEnd,
            rotate: rndRot + gsap.utils.random(-60, 60),
            opacity: 0.9,
            duration: rndDur,
            ease: 'power2.out',
            delay: rndDelay,
            onComplete: () => el.remove()
          }
        )
      }
    }

    onMounted(async () => {
      await nextTick()

      stInstance = ScrollTrigger.create({
        trigger: raiz.value,
        start: 'top 85%',
        once: true,
        onEnter: () => {
          const tl = gsap.timeline({ defaults: { ease: 'power3.out' } })

          if (florRef.value) {
            tl.fromTo(
              florRef.value,
              { y: -28, opacity: 0, rotate: -6, filter: 'blur(4px)' },
              { y: 0, opacity: 0.9, rotate: 0, filter: 'blur(0px)', duration: 0.45 }
            )
          }

          const serifEl = tituloRef.value?.querySelector('.serif')
          const scriptEl = tituloRef.value?.querySelector('.script')

          if (serifEl) {
            tl.fromTo(
              serifEl,
              { opacity: 0, y: -24, filter: 'blur(6px)', letterSpacing: '0.03em' },
              { opacity: 1, y: 0, filter: 'blur(0)', letterSpacing: '0em', duration: 0.5 }
            )
          }

          if (scriptEl) {
            tl.fromTo(
              scriptEl,
              { opacity: 0, y: 18, filter: 'blur(5px)' },
              { opacity: 1, y: 0, filter: 'blur(0)', duration: 0.45 },
              '-=0.2'
            )
          }

          if (textoRef.value) {
            tl.fromTo(
              textoRef.value,
              { opacity: 0, y: 14, filter: 'blur(3px)' },
              { opacity: 1, y: 0, filter: 'blur(0)', duration: 0.4 },
              '-=0.05'
            )
          }

          if (sobreRef.value) {
            tl.fromTo(
              sobreRef.value,
              { opacity: 0, y: -80, rotate: 0.001, scale: 0.9, filter: 'blur(0px)' },
              { opacity: 1, y: 0, scale: 1, duration: 0.55, ease: 'back.out(1.6)' },
              '-=0.05'
            )
          }

          if (graciasRef.value) {
            tl.fromTo(graciasRef.value, { opacity: 0, y: 10 }, { opacity: 1, y: 0, duration: 0.35 }, '-=0.1')
          }

          toDer = setTimeout(() => crearLluvia(lluviaDer.value, 'der', 12), 80)
          toIzq = setTimeout(() => crearLluvia(lluviaIzq.value, 'izq', 12), 220)
        }
      })
    })

    onUnmounted(() => {
      if (toDer) clearTimeout(toDer)
      if (toIzq) clearTimeout(toIzq)
      if (stInstance) stInstance.kill()
      ScrollTrigger.refresh()
    })

    return {
      raiz,
      florRef,
      tituloRef,
      textoRef,
      sobreRef,
      graciasRef,
      lluviaIzq,
      lluviaDer,
      sobrePng
    }
  }
}
</script>

<style scoped>
.lluvia-sobres {
  position: relative;
  max-width: 520px;
  margin: 0 auto;
  padding: 48px 20px 56px;
  text-align: center;
  overflow: hidden;
}

/* 🎥 Video de Fondo */
.video-fondo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
  pointer-events: none;
  z-index: 1;
}

.contenido {
  position: relative;
  z-index: 2;
}

/* ===================================================
   TEXTOS Y SOBRES
   =================================================== */
.titulo {
  margin: 0 0 10px;
  color: #fff;
  line-height: 1.05;
}
.titulo .serif {
  font-family: 'britishgruesa', serif;
  font-size: 56px;
  display: inline-block;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}
.titulo .script {
  font-family: 'nombre', cursive;
  font-size: 44px;
  font-weight: 400;
  display: inline-block;
  opacity: 0.95;
  text-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.texto {
  font-family: 'quote', serif;
  color: #fff;
  font-size: 18px;
  line-height: 1.5;
  max-width: 420px;
  margin: 12px auto 18px;
  opacity: 0.95;
  text-shadow: 0 1px 6px rgba(0, 0, 0, 0.4);
}

.icono-sobre {
  width: 110px;
  height: auto;
  display: block;
  margin: 8px auto 8px;
  filter: drop-shadow(0 6px 16px rgba(0, 0, 0, 0.35));
}

.gracias {
  font-family: 'padres', serif;
  font-size: 24px;
  color: #ffffff;
  letter-spacing: 0.08em;
  font-weight: 800;
  margin: 4px 0 0;
  text-shadow: 0 0 12px rgba(255, 255, 255, 0.5);
}

.lluvia {
  position: absolute;
  inset: 0;
  pointer-events: none;
  z-index: 3;
}
.lluvia-izq { left: 0; }
.lluvia-der { right: 0; }

.sobre-lluvia {
  position: absolute;
  top: -10%;
  left: 0;
  width: 28px;
  height: auto;
  opacity: 0.9;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.25));
}

@media (max-width: 380px) {
  .titulo .serif { font-size: 50px; }
  .titulo .script { font-size: 40px; }
  .icono-sobre { width: 96px; }
}
</style>